import React, { ReactElement } from 'react';
import { Pressable, ViewStyle } from 'react-native';
import Style from '../constants/Style';

export type PressableState = { hovered: boolean, pressed: boolean };

interface PressableStyledProps {
  style?: ViewStyle | ViewStyle[],
  children: ReactElement[] | ReactElement,
  onPress?: () => void,
  onLongPress?: () => void,
  testID?: string,
  disabled?: boolean,
  maintainOpacityWhenDisabled?: boolean,
  row?: boolean,
  onLayout?,
  hitSlop?,
}

const PressableStyled = ({
  style, children, onPress, onLongPress, testID, disabled, row, maintainOpacityWhenDisabled,
  onLayout, hitSlop,
}: PressableStyledProps) => <Pressable
    {...{
      children, onPress, testID, disabled, onLongPress, onLayout, hitSlop,
    }}
    style={({ hovered, pressed }: PressableState) => [
      (disabled && !maintainOpacityWhenDisabled)
        ? Style.disabled : [hovered && Style.hovered, pressed && Style.pressed],
      row && { flexDirection: 'row' }, style,
    ]}
  />;

export default PressableStyled;
